import React, { useEffect } from "react";
import { formatDetailValue, getNestedValue } from "../utils/valueUtils";

export default function DetailsPopup({
  title = "Details",
  source,
  fields = [],
  loading = false,
  error = "",
  fallbackText = "No details found.",
  onClose,
}) {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", handleEsc);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="safety-details-popup"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onMouseDown={onClose}
    >
      <div
        className="safety-details-popup__box"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="safety-details-popup__header">
          <h3>{title}</h3>

          <button
            type="button"
            className="safety-details-popup__close"
            onClick={onClose}
            aria-label="Close details"
          >
            ×
          </button>
        </div>

        <div className="safety-details-popup__body">
          {loading ? (
            <div className="safety-details-popup__state">
              Loading details...
            </div>
          ) : error ? (
            <div className="safety-details-popup__state safety-details-popup__state--error">
              {error}
            </div>
          ) : !source ? (
            <div className="safety-details-popup__state">{fallbackText}</div>
          ) : (
            <div className="safety-details-popup__grid">
              {fields.map((fieldKey) => {
                const value = getNestedValue(source, fieldKey);

                return (
                  <div key={fieldKey} className="safety-details-popup__item">
                    <div className="safety-details-popup__key">{fieldKey}</div>
                    <div className="safety-details-popup__value">
                      {formatDetailValue(value)}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
